module.exports = __webpack_public_path__ + "img/travelService-ganbo-title.efb48cc5.png";